import { connect } from "react-redux";
import RecordingComponent from "../../Components/RecordingComponent/RecordingComponent";
const mapStateToProps = (state) => ({
  callFlows: state.reducer.callFlows,
  supervisedAgentDetails: state.reducer.supervisedAgentDetails,
  supervisedAgentIds : state.reducer.supervisedAgentIds,
  callFlowsIds : state.reducer.callFlowsIds,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RecordingComponent);
